import type { ApiPagination, ApiPayloadList } from "@/services/api";

export const getListPayloadData = <Data = unknown>(
  payload: ApiPayloadList<Data>
) => payload?.data;

export const getListPayloadPagination = <Data = unknown>(
  payload: ApiPayloadList<Data>
) => {
  const { meta, links } = payload;

  return { links, meta } as ApiPagination;
};
